import { render, staticRenderFns } from "./BackgroundLayout.vue?vue&type=template&id=7c9282a8"
import script from "./BackgroundLayout.vue?vue&type=script&lang=ts"
export * from "./BackgroundLayout.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports